import React from 'react'

export default function Interest({interest,removeInterest,id}) {
	return (
		<>
			<li className="remove-list-style"><span>{removeInterest && (<button onClick={()=>removeInterest(id)}><i class="far fa-trash-alt"></i></button>)}</span>{interest}</li>
		</>
	)
}